import { Component, OnInit , ElementRef, ViewChild, Renderer2,  Input, Output, EventEmitter} from '@angular/core';

import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-double-split-dropdown',
  templateUrl: './double-split-dropdown.component.html',
  styleUrls: ['./double-split-dropdown.component.scss']
})
export class DoubleSplitDropdownComponent implements OnInit {

  @ViewChild('myInput') divElement: ElementRef;
  @ViewChild('dropdown') dropdownElement: ElementRef;
  @Input() selectedItem: any;
  @Input() data: any;
  @Output() onChange = new EventEmitter;
  @Input() formControls: FormControl;
  @Input () eligibleVehicleLable:string = 'Eligible';
  @Input() OtherVehicle: string='Optional'
  @Input() showWarnigPopup:boolean = true;


  title = 'tollupdate';
  open = false;
  openPopup = false;
  selectedValue = "Select";
  slectecControl = new FormControl();
  optionsLength = 0;
  costCentedAddedToas = false;
  Chosenvalue: string;
  constructor(private renderer: Renderer2) {
  }




  ngOnInit() {
    if (this.formControls.value !== "") {
    this.selectedValue = this.formControls.value;
    }
    this.slectecControl.disable();
    this.formControls.valueChanges.subscribe((res) => {
      if (res.length) {
      this.selectedValue = res;
      }
    });
  }
  ngAfterViewInit() {
    this.setPosition();
  }

  setPosition() {
    const rect = this.divElement.nativeElement.getBoundingClientRect();

    this.renderer.setStyle(this.dropdownElement.nativeElement, 'position', 'absolute');
  }



  optionClicked(val: string, type: string){
    this.toggleDropDown();
    if (this.selectedValue != val && this.showWarnigPopup) {
    type === 'all' ? this.addOption(val) : this.setValue(val);
    }
    else{
      this.setValue(val)
    }
  }

  setValue(val: string)
  {
    this.formControls.setValue(val);
    this.onChange.emit(val);
  }

  addOption(val)
  {
    this.openPopup = true;
    this.Chosenvalue = val;
  }
  proceedWithNonAllocatedVechicle()
  {
    this.setValue(this.Chosenvalue);
    this.openPopup = false;
  }

  toggleDropDown(){
    this.open = !this.open;
  }




}
